import { render, staticRenderFns } from "./EditNickname.vue?vue&type=template&id=475bfc4d&scoped=true"
import script from "./EditNickname.vue?vue&type=script&lang=js"
export * from "./EditNickname.vue?vue&type=script&lang=js"
import style0 from "./EditNickname.vue?vue&type=style&index=0&id=475bfc4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475bfc4d",
  null
  
)

export default component.exports